<template>
  <div class="mobile-bottom-nav font-rubik">
    <div class="nav-links-container">
      <div class="ca-logo-container flex items-center justify-center shadow-lg">
        <img src="@/images/header/mobile-bottom-nav/container-alliance-logo-icon.svg" alt="Container Alliance">
      </div>

      <div
        v-for="solution in solutionsArr"
        :key="`mobile-nav-${solution.slug}`"
        :class="['nav-link', isActive(solution.slug) ? 'active' : '']"
        :style="isActive(solution.slug) ? { '--active-color': colorMapping[solution.key] } : {}"
      >
        <a :href="solution.slug" class="nav-link-item flex items-center justify-center">
          <img :src="isActive(solution.slug) ? solution.iconSelected : solution.iconDefault" alt="icon" />
          <span :class="['nav-link-title', isActive(solution.slug) ? 'active' : '']" v-html="solution.title"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import containerAccessories_default from '@/images/header/mobile-bottom-nav/default/container-accessories.svg'
import containerModifications_default from '@/images/header/mobile-bottom-nav/default/container-modifications.svg'
import containerRentals_default from '@/images/header/mobile-bottom-nav/default/container-rentals.svg'
import containerSales_default from '@/images/header/mobile-bottom-nav/default/container-sales.svg'
import portableOffices_default from '@/images/header/mobile-bottom-nav/default/portable-offices.svg'
import refrigeratedContainers_default from '@/images/header/mobile-bottom-nav/default/refrigerated-containers.svg'

import containerAccessories_selected from '@/images/header/mobile-bottom-nav/selected/container-accessories.svg'
import containerModifications_selected from '@/images/header/mobile-bottom-nav/selected/container-modifications.svg'
import containerRentals_selected from '@/images/header/mobile-bottom-nav/selected/container-rentals.svg'
import containerSales_selected from '@/images/header/mobile-bottom-nav/selected/container-sales.svg'
import portableOffices_selected from '@/images/header/mobile-bottom-nav/selected/portable-offices.svg'
import refrigeratedContainers_selected from '@/images/header/mobile-bottom-nav/selected/refrigerated-containers.svg'

export default {
  name: 'MobileBottomNav',
  props: {
    organization: {
      required: true,
      type: Object
    },
    solutions: {
      required: true,
      type: Array
    },
    solutionsPath: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      solutionsArr: [],
      keywordMappings: [
        { keyword: 'refrigerated container rentals', output: 'Refrigerated Rentals', key: 'refrigerated-container-rentals' },
        { keyword: 'refrigerated containers', output: 'Refrigerated Containers', key: 'refrigerated-containers' },
        { keyword: 'container modifications', output: 'Modifications', key: 'container-modifications' },
        { keyword: 'portable offices', output: 'Portable Offices', key: 'portable-offices' },
        { keyword: 'accessories', output: 'Accessories', key: 'accessories' },
        { keyword: 'container sales', output: 'Sales', key: 'container-sales' },
        { keyword: 'sales', output: 'Sales', key: 'container-sales' },
        { keyword: 'rentals', output: 'Rentals', key: 'container-rentals' },
        { keyword: 'modifications', output: 'Modifications', key: 'container-modifications' },
        { keyword: 'portable', output: 'Portable Offices', key: 'portable-offices' },
        { keyword: 'refrigerated', output: 'Refrigerated Containers', key: 'refrigerated-containers' }
      ],
      iconMapping: {
        'container-sales': {
          default: containerSales_default,
          selected: containerSales_selected
        },
        'container-rentals': {
          default: containerRentals_default,
          selected: containerRentals_selected
        },
        'container-modifications': {
          default: containerModifications_default,
          selected: containerModifications_selected
        },
        'refrigerated-containers': {
          default: refrigeratedContainers_default,
          selected: refrigeratedContainers_selected
        },
        'refrigerated-container-rentals': {
          default: refrigeratedContainers_default,
          selected: refrigeratedContainers_selected
        },
        'portable-offices': {
          default: portableOffices_default,
          selected: portableOffices_selected
        },
        'accessories': {
          default: containerAccessories_default,
          selected: containerAccessories_selected
        }
      },
      colorMapping: {
        'container-sales': '#3565FC',
        'container-rentals': '#06B6D4',
        'container-modifications': '#14B8A6',
        'refrigerated-containers': '#84CC16',
        'refrigerated-container-rentals': '#84CC16',
        'portable-offices': '#EA580C',
        'accessories': '#DC2626'
      }
    }
  },
  mounted() {
    this.createSolutionsArray(this.solutions)
  },
  computed: {
    currentUrl() {
      return window.location.pathname.replace(/\/$/, '')
    }
  },
  methods: {
    createSolutionsArray(solutions) {
      this.solutionsArr = solutions.map(solution => {
        const formattedTitle = this.formatTitle(solution.title)
        const slug = this.getSolutionSlug(solution.id)
        const key = this.getSolutionKey(solution.title)
        const icons = this.iconMapping[key] || {}
        return {
          title: formattedTitle,
          slug: slug,
          iconDefault: icons.default,
          iconSelected: icons.selected,
          key: key
        }
      })
    },
    formatTitle(title) {
      const lowerTitle = title.toLowerCase()
      for (const mapping of this.keywordMappings) {
        if (lowerTitle.includes(mapping.keyword.toLowerCase())) {
          return mapping.output
        }
      }
      return title.replace(/\b\w/g, l => l.toUpperCase())
    },
    getSolutionKey(title) {
      const lowerTitle = title.toLowerCase()
      for (const mapping of this.keywordMappings) {
        if (lowerTitle.includes(mapping.keyword.toLowerCase())) {
          return mapping.key
        }
      }
      // Return a default key if no match is found
      return 'default'
    },
    getSolutionSlug(id) {
      return this.solutionsPath[id.toString()] || '#'
    },
    isActive(slug) {
      const currentUrl = window.location.pathname.replace(/\/$/, '')
      return currentUrl === slug.replace(/\/$/, '')
    }
  }
}
</script>

<style scoped>
.mobile-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  background-color: white;
  border-top: 1px solid #E2E1DE;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.nav-links-container {
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
}

.nav-link {
  flex: 1;
  text-align: center;
}

.nav-link-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #0C0E20;
}

.nav-link-item img {
  width: 20px;
  height: 20px;
  margin-bottom: 5px;
}

.nav-link-item span.active {
  color: #334155;
}

.nav-link-title {
  font-size: 8px;
  font-weight: 400;
  line-height: 6px;
  letter-spacing: -0.04em;
  color: #33415599;
  max-width: 55px;
}

.ca-logo-container {
  margin-left: 20px;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  border: 1px solid #EDE9E3;
}

.nav-link {
  position: relative;
}

.nav-link.active::before {
  content: "";
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translate(-50%);
  width: 40px;
  height: 4px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  background-color: var(--active-color, transparent);
  transition: background-color .3s ease;
}

.nav-link:hover::before,
.nav-link .nav-link-item .active + ::before {
  display: block;
}
</style>
